import { render, staticRenderFns } from "./modalSelectGolferToFight.vue?vue&type=template&id=33278806"
import script from "./modalSelectGolferToFight.vue?vue&type=script&lang=js"
export * from "./modalSelectGolferToFight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports